
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import { harajukuTheGreatBurgerSelectionTopImage } from "@src/constants/images";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { meta as theGreatBurgerPageMeta } from "./the_great_burger.mdx";
export const meta = {
  path: "/media/harajuku/the_great_burger_selection",
  title: "【目的別】ザ グレイトバーガーの人気メニュー７選の選び方！",
  description: "せっかく行列に並んで入ったのに、メニューがたくさんあって選ぶのに時間がかかって焦って頼んでしまう。そんな悩みはありませんか？だからこそ、グレイトバーガー を知り尽くした筆者が、目的に合わせてメニューの選び方をお伝えします！",
  topImg: harajukuTheGreatBurgerSelectionTopImage,
  author: murakamiMasanori,
  tags: ["行列店", "ハンバーガー", "駅近", "おしゃれな内装", "デート", "メニュー詳細", "裏原"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`ザ グレートバーガー とは？`}</h2>
    <p>{`原宿駅、明治神宮前駅から徒歩 5 分。`}</p>
    <p>{`おしゃれな若者たちが集う `}<strong parentName="p">{`「裏原」`}</strong>{` とよばれる場所に位置し、ガラス張りの外観から見える店内は、
ランチの時間帯に行くとまさに`}<strong parentName="p">{`南カリフォルニア`}</strong>{`にいるかのような気持ちにさせてくれます。`}</p>
    <p>{`半年かけて作成したと言われる特製のバンズや、
外装と内装の一つ一つにオーナーの`}<strong parentName="p">{`こだわり`}</strong>{`が詰まったお店になります。`}</p>
    <p>{`休日に長蛇の列を作る理由はまさにそのこだわりにあると思うので、
是非、ザ・グレイトバーガー の思いの詰まったハンバーガーを目的別にご紹介させていただきます！`}</p>
    <h2>{`【目的別】メニュー７選をご紹介！`}</h2>
    <h3>{`【人気 No.1 なら】アボカドサルサチーズバーガー`}</h3>
    <InstaImage postId="BBz4tdmsp3b" mdxType="InstaImage" />
    <p>{`1,350 円(税抜)
ザグレイトバーガー といえば、このアボカドサルサチーズバーガーが 1 番人気の絶品メニューになります。
ボリューミーな見た目に、パテ、アボカド、チーズとバランスが取れた一品になっています。
初めて来店される方やインスタ映えを狙う方は、食べてみるのはいかがでしょう？`}</p>
    <hr></hr>
    <h3>{`【とにかく肉をガッツリ食べたいなら】ダブルチーズバーガー`}</h3>
    <InstaImage postId="B7n9SuhJpnG" mdxType="InstaImage" />
    <p>{`1,550 円(税抜)`}</p>
    <p>{`見た目からもお分かりいただけると思いますが、
ジューシーなパテが２層になっている、肉をガッツリ食べたい方には、文句なしの一品。`}</p>
    <hr></hr>
    <h3>{`【チーズ好きなら】ゴルゴンチーズバーガー`}</h3>
    <InstaImage postId="B7THawsBjFX" mdxType="InstaImage" />
    <p>{`1,150 円(税抜)`}</p>
    <p>{`チーズ好きのためにある絶品バーガー。
ゴルゴンゾーラの風味が肉の旨味を引き出してくれる、リピート間違いなしの一品。
アボカドやその他のトッピングを追加するのもオススメです！`}</p>
    <hr></hr>
    <h3>{`【コスパ重視なら】ハンバーガー`}</h3>
    <InstaImage postId="B-XglLsDoGb" mdxType="InstaImage" />
    <p>{`950 円(税抜)`}</p>
    <p>{`ハンバーガーを食べたいけど、値段は抑えたい。
トッピングではなく、そのお店本来の味が食べたい方は、こちらのハンバーガーを食べたい方におすすめの一品です！るので、ボリュームも文句なしだと思います！
選んでみるのはいかがでしょう？`}</p>
    <hr></hr>
    <h3>{`【ベジタリアンなら】フレッシュベジタブルバーガー`}</h3>
    <InstaImage postId="Bo6f067BIZg" include={[1]} mdxType="InstaImage" />
    <p>{`1,100 円(税抜)`}</p>
    <p>{`なんとパテの代わりにアボカドを挟んでいるハンバーガーになります！
ハンバーガーは脂っこくて食べるのが苦手、健康に気を遣っている方は、こちらの一品がオススメです！`}</p>
    <hr></hr>
    <h3>{`【スパイシーが好きなら】チリバーガー`}</h3>
    <InstaImage postId="B8bBygNBCG0" mdxType="InstaImage" />
    <p>{`1,100 円(税抜)`}</p>
    <p>{`塩っけだけじゃ何か物足らない。
そんな方のためにスパイシーなチリバーガーがザグレートバーガーでは食べられます！
チーズトッピングをするとまた変わった味になるので、是非そちらも召し上がってみてください！`}</p>
    <hr></hr>
    <h3>{`【変わった味が食べたいなら】アボカドモッツァレラパインバーガー`}</h3>
    <InstaImage postId="B_pTdKxjr1W" mdxType="InstaImage" />
    <p>{`1,350 円(税抜)`}</p>
    <p>{`パインが入ることでハワイアンのような爽やかな味わいになります。
パインによる酸味が、アボカドの甘さが引き立て、肉とチーズの塩味で締める一品となってお利、
普段食べているバーガーと違う味を体験してみたい方にはオススメの一品です！`}</p>
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`目的別でザ グレートバーガー の選び方をご紹介してきましたが、いかがでしたでしょうか？
トッピングだけでなく、サイドメニューもたくさん豊富にあるので、是非足を運んで試してみてください！`}</p>
    <LinkWithThumbnail meta={theGreatBurgerPageMeta} mdxType="LinkWithThumbnail" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;